var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.images),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.index = i}}})}),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }